<template>
  <p :class="computedPercentualClass">
    <slot>{{ percentual.formatted }}</slot>
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { NumberFormatted } from '@/modules/trade/types';

interface Props {
  percentual: NumberFormatted;
}
const props = defineProps<Props>();

const computedPercentualClass = computed(() => {
  return [
    'percentual-text__text--secondary',
    {
      'percentual-text__text--positive':
        props.percentual && props.percentual.value > 0,
      'percentual-text__text--negative':
        props.percentual && props.percentual.value < 0
    }
  ];
});
</script>

<style lang="less" scoped>
.percentual-text {
  &__text {
    &--positive {
      color: @monetary-positive;
    }
    &--negative {
      color: @monetary-negative;
    }
  }
}
</style>
